/**
 * Higher Order Component used in order to manage the reload event on registration pages.
 * It causes the redux store to be cleaned up, so the data inserted at the previopus pages would be lost
 * In this cases, in necessary to bring back the user to the first page
 */

import { ReactNode } from 'react';
import { useAppSelector } from '../hooks/redux';
import appRoutes from './app-routes';
import { useAppNavigation } from '../utils/navigation.utils';

export const RegistrationPageWrapper = (component: ReactNode) => {
  const { flowStarted } = useAppSelector(
    (state) => state.features.userRegistration
  );
  const { appLink } = useAppNavigation();
  return flowStarted
    ? component
    : appLink(appRoutes.UserRegistration as any, true);
};
